<template>
  <div>
    <SfModal :visible="visable" class="HomeModal">
      <template #modal-bar>
        <div class="title" style="text-align:center;">
          <h4 style="padding:2rem;margin:0;padding-bottom:0;"></h4>
        </div>
      </template>
      <template #close>
        <div>
          <SfIcon icon="cross" size="1.25rem" @click="closeModal" />
        </div>
      </template>
      <template #default>
        <div class="context">
          <div v-if="HomeModalData.content" v-html="HomeModalData.content" ref="ahtml"></div>
        </div>
      </template>
    </SfModal>
  </div>
</template>
<script>
import {
  SfButton,
  SfModal,
  SfIcon
} from '@storefront-ui/vue';
import { ref, computed, onMounted } from '@nuxtjs/composition-api';
export default {
  components: {
    SfButton,
    SfModal,
    SfIcon
  },
  setup(props, context) {
    const ahtml = ref();
    const HomeModalData = computed(() => {
      const regex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/gi;
      if (context?.root?.$options?.$mallConfig?.mall_web_config?.homeModal) {
        const HomeModal = JSON.parse(JSON.stringify(context?.root?.$options?.$mallConfig?.mall_web_config.homeModal));
        if (HomeModal) {
          // 使用replace方法替换匹配到的内容
          HomeModal.content = HomeModal?.content.replace(regex, (match, href) => {
            const locale = context?.root?.$cookies.get('vsf-locale');
            if (!href.startsWith('http://') && !href.startsWith('https://')) {
              const updatedHref = `${'/' + locale}${href}`;
              const updatedAnchorTag = match.replace(href, updatedHref);
              return updatedAnchorTag;
            } else {
              return match;
            }
          });
          return HomeModal;
        }
      }
    });
    const visable = ref(false);
    const closeModal = () => {
      visable.value = false;
      // 获取当前事件戳
      const timestamp = new Date().getTime();
      context?.root?.context.$cookies.set('IS_HOME_MODAL', { time: timestamp });
    };
    onMounted(() => {
      const IS_HOME_MODAL = context?.root?.context?.$cookies.get('IS_HOME_MODAL');
      const currentTimestamp = new Date().getTime();
      // 判断当前时间戳是否比cookies中的时间戳大2小时
      if ((IS_HOME_MODAL && currentTimestamp - (IS_HOME_MODAL?.time || 0) > 7200000) && HomeModalData.value?.open === '1') {
        context?.root?.context?.$cookies?.remove('IS_HOME_MODAL');
        visable.value = true;
      } else if (HomeModalData.value?.open === '1' && !IS_HOME_MODAL) {
        visable.value = true;
      }
      try {
        let imgs = [];
        if (ahtml.value) {
          // 通过ref获取到所有有usemap的dom元素
          imgs = ahtml.value.querySelectorAll('img[usemap]');
        }
        // 通过遍历所有的dom元素，通过usemap的值获取到对应的map元素
        imgs?.forEach((img, index) => {
          // 获取img元素的height和width
          const alt = img.getAttribute('alt');
          if (index !== -1 && alt.indexOf('autosize1') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            // const imgWidth = img.width;
            // const imgHeight = img.height;
            const imgHeight = img.getAttribute('height');
            const imgWidth = img.getAttribute('width');
            // 遍历所有的area元素，获取到对应的href值
            const newImg = ahtml.value.querySelector('img[usemap=' + `"#${mapName}"` + ']');
            const newImgWidth = newImg.clientWidth;
            const newImgHeight = newImg.clientHeight;
            const widthRatio = Number(newImgWidth / imgWidth).toFixed(2);
            const heightRatio = Number(newImgHeight / imgHeight).toFixed(2);
            areas.forEach(area => {
              // 根据img按newimg的比例缩放area的坐标
              const coords = area.coords.split(',');
              const adjustedCoords = coords.map((value, index) => {

                const adjustedValue = index % 2 === 0 ? value * widthRatio : value * heightRatio;
                // 将每一个调整后的坐标值四舍五入到指定的小数位数
                return Number(adjustedValue.toFixed(2));
              }
              );
              area.style.backgroundColor = 'red';
              // 判断area.href有值且是已/开头
              //
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${'/' + locale}${href}`);
              }
              area.coords = adjustedCoords;
            });
          } else if (index !== -1 && alt.indexOf('autosize0') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            areas.forEach(area => {
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${ '/' + locale}${href}`);
              }
            });
          }
        });
        const videos = ahtml.value?.querySelectorAll('video');
        videos?.forEach((video) => {
          if (video.autoplay) {
            setTimeout(() => {
              video.play();
            }, 1000);
          }
        });
      } catch (e) {
        console.log('e', e);
      }
    });
    return {
      visable,
      closeModal,
      HomeModalData,
      ahtml
    };
  }
};
</script>
<style lang="scss">
.HomeModal {
  --overlay-z-index: 9999999999;
  --modal-index: 9999999999;

  @include for-mobile {
    --modal-left: 10vw;
    --modal-top: 10vh;
    --modal-height-min: 22vh;
    --modal-height-max: 75vh;
    --modal-height: auto;
    --modal-width: 80vw;

    .desktop-only.sf-button {
      display: block !important;
    }

    .sf-modal__container {
      height: var(auto) !important;
      min-height: var(--modal-height-min);
      max-height: var(--modal-height-max);

      .sf-modal__content {
        overflow-y: hidden;
        max-height: var(--modal-height-max);
      }
    }
  }

  @include for-desktop {
    --modal-width: 80VW;
    .sf-modal__content {
      overflow-y: hidden;
    }
  }

  --modal-content-padding: 0;

  .title {
    color: #000;
    top: 0;
    width: 100%;
    height: 2rem;
  }

  .context {
    color: #000;
    padding: 0rem 2rem 0 2rem;

    .foot {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>
